import CoachSuggestion from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestion';
import CoachSuggestionContent from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestionContent';
import CoachSuggestionsFooter from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestionFooter';
import CoachSuggestionHeader from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestionHeader';
import CoachSuggestions from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestions';

const Suggestion = Object.assign(CoachSuggestion, {
  Header: CoachSuggestionHeader,
  Footer: CoachSuggestionsFooter,
  Content: CoachSuggestionContent,
});

export default Object.assign(CoachSuggestions, { Suggestion });
